import { SelectField } from '@dispatch/web/ui';
import { Grid } from '@mui/material';
import { useContext } from 'react';
import {
  Control,
  FieldValues,
  UseFieldArrayAppend,
  UseFormWatch,
} from 'react-hook-form';
import { ResourceContext } from '../../ResourcesDetails';
import { v4 as uuidv4 } from 'uuid';
import { AttributeForm, ResourceForm } from '@dispatch/shared/types';
import { emptyBoolForm } from '@dispatch/shared';

export type AttributeAddProps = {
  append: UseFieldArrayAppend<FieldValues, 'attributes'>;
  control: Control<FieldValues>;
  watch: UseFormWatch<ResourceForm>;
  isReadOnly?: boolean;
};

export function AttributeAdd({
  append,
  control,
  watch,
  isReadOnly,
}: AttributeAddProps) {
  const { data } = useContext(ResourceContext);

  const handleAddAttribute = (value: unknown) => {
    const rawValue = value as { title: string; value: string };
    const selectedAttribute = getSelectedAttributeData(rawValue.value);

    append(selectedAttribute);
  };

  const getSelectedAttributeData = (integrationGUID: string): AttributeForm => {
    const selectedAttribute = data?.company?.attributeDefinition?.find(
      (attribute) => attribute.integrationGUID === integrationGUID
    );

    return {
      integrationGUID: uuidv4(),
      attributeDefinitionIntegrationGUID:
        selectedAttribute?.integrationGUID || '',
      displayName: selectedAttribute?.displayName || '',
      selectedAttributeValuesVarchars: [],
      selectedAttributeValuesBools: emptyBoolForm(),
    };
  };

  const getFilteredOptions = () => {
    const formAttributes = watch('attributes');
    const companyAttributes = data?.company?.attributeDefinition;

    if (!formAttributes || !companyAttributes) {
      return (
        companyAttributes?.map((value) => {
          return {
            title: value.displayName,
            value: value.integrationGUID,
          };
        }) || []
      );
    }

    const filteredCompanyAttributes = companyAttributes?.filter(
      (companyAttr) => {
        return !formAttributes.find(
          (formAttr) =>
            formAttr.attributeDefinitionIntegrationGUID ===
            companyAttr.integrationGUID
        );
      }
    );

    return filteredCompanyAttributes.map((value) => {
      return {
        title: value.displayName,
        value: value.integrationGUID,
      };
    });
  };

  return (
    <div
      style={{
        padding: '24px',
      }}
    >
      <Grid container rowSpacing={4} spacing={2}>
        <Grid data-testid="add-attribute" size={6}>
          <SelectField
            id="addSelectedAttributeGUID"
            name="addSelectedAttributeGUID"
            label="Add New Attribute"
            control={control}
            onValueChange={handleAddAttribute}
            options={getFilteredOptions()}
            disabled={isReadOnly}
          />
        </Grid>
      </Grid>
    </div>
  );
}
